import { render, staticRenderFns } from "./move_client_stage.vue?vue&type=template&id=6db5d20f"
import script from "./move_client_stage.vue?vue&type=script&lang=js"
export * from "./move_client_stage.vue?vue&type=script&lang=js"
import style0 from "./move_client_stage.vue?vue&type=style&index=0&id=6db5d20f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports